import FormWidget from "../form-widget.js";
import { zxcvbn } from "@zxcvbn-ts/core";


interface ScoreConfig {
    id: number;
    color: string;
    icon: string;
    text: string;
}

interface PasswordStrengthWidgetOptions {
    scores: ScoreConfig[]
}

const defaultOptions: PasswordStrengthWidgetOptions = {
    scores: [
        {
            id: 0,
            color: 'red',
            icon: 'fa-exclamation-triangle',
            text: 'common:passwordStrengthEvaluation.worst'
        },
        {
            id: 1,
            color: 'red',
            icon: 'fa-exclamation-triangle',
            text: 'common:passwordStrengthEvaluation.bad'
        },
        {
            id: 2,
            color: 'orange',
            icon: 'fa-exclamation-circle',
            text: 'common:passwordStrengthEvaluation.weak'
        },
        {
            id: 3,
            color: 'yellowgreen',
            icon: 'fa-smile-beam',
            text: 'common:passwordStrengthEvaluation.good'
        },
        {
            id: 4,
            color: 'green',
            icon: 'fa-smile',
            text: 'common:passwordStrengthEvaluation.strong'
        }

    ]
};

class PasswordStrengthWidget extends FormWidget {
    protected options: PasswordStrengthWidgetOptions;
    public override init() {
        this.options = this.assignConfig<PasswordStrengthWidgetOptions>(defaultOptions, this.config);
    }
    public override process() {
        const fieldEl = this.element as HTMLInputElement;

        const meterEl = document.createElement('div');
        meterEl.setAttribute('class', 'password-strength-meter progress');
        meterEl.innerHTML = '<div class="progress-bar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>';

        const feedbackEl = document.createElement('div');
        feedbackEl.setAttribute('class', 'password-strength-feedback text-small');

        const wrapperEl = document.createElement('div');
        wrapperEl.setAttribute('class', 'password-strength mt-2 mb-2');
        wrapperEl.append(feedbackEl);
        wrapperEl.append(meterEl);

        const progressBar = meterEl.querySelector<HTMLElement>('.progress-bar')!;

        fieldEl.closest('.form-group')?.append(wrapperEl);
        fieldEl.addEventListener('input', (ev: Event) => {
            const result = zxcvbn(fieldEl.value);
            const scoreConfig: ScoreConfig | null = this.options.scores.find((item: ScoreConfig) => { return item.id === result.score })!;
            const width = (100*result.score/4);
            progressBar?.setAttribute('area-valuenow', width.toString());
            progressBar.style.width = width + '%';
            progressBar.style.background = scoreConfig.color;
            feedbackEl.innerHTML = '';
            if(fieldEl.value != '') {
                let text = window.ThiemeCore.Lang.translate('common:passwordStrength')+': ';
                text += window.ThiemeCore.Lang.translate(scoreConfig.text);
                feedbackEl.innerHTML = text;
            }

        });
        if(fieldEl.value != '') {
            fieldEl.dispatchEvent(new Event('input'));
        }
    }

}

export type { PasswordStrengthWidgetOptions, ScoreConfig };
export default PasswordStrengthWidget;
